import { QueryClient } from '@tanstack/react-query';

/**
 * Shared React Query client
 *
 * Defines sensible defaults for all queries/mutations:
 *  - Queries stay "fresh" for 60 s before refetching.
 *  - Failed queries retry once.
 *  - No refetch on window focus (avoids extra network chatter).
 *  - Mutations do not auto-retry.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 60_000,
      staleTime: 60_000,
      retry: 0,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
